<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-xl-8">
                    <div class="trinka_cloud_banner_text">
                        <h1>Trinka的主要功能</h1>
                        <p>Trinka是世界上第一個專為學術和技術寫作而定製的文法和語言增強工具。它的與眾不同之處在於它可以與作者協同工作，其功能超越了文法和拼寫檢查的範圍，能確保整體語言的增強。</p>
                    </div>
                </div>
                <div class="col-xl-4">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/FeaturesTopBanner.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="advanceGrammerSpellCheck_section backgrondSecitons_outer">
        <div class="container">
            <div class="row">
                <div class="col-xl-5">
                    <div class="spellcheck_heading">
                        <h2>高級寫作需要高級檢查， Trinka出場</h2>
                        <div class="HeadingSubLine"></div>
                        <p>學術寫作需要清晰、簡潔、正式、客觀和可讀。Trinka可以幫助您改善所有這些方面，讓您得到寫作的最佳版本。</p>
                    </div>
                </div>
                <div class="col-xl-7">
                    <div class="spellcheckGrammerCheck_slider">
                        <div id="spellcheckGrammerCheck" class="carousel slide" data-ride="carousel">
                            <!-- Indicators -->
                            <div class="bullet_points_sections">
                                <ul class="carousel-indicators">
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="0" class="active">
                                        <span></span>
                                        高級文法
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="1">
                                        <span></span>
                                        句構
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="2">
                                        <span></span>
                                        選字
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="3">
                                        <span></span>
                                        用法和
                                        <br>風格
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="4">
                                        <span></span>
                                        美式/英式
                                        <br />風格
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="5">
                                        <span></span>
                                        高級拼寫
                                    </li>
                                </ul>
                            </div>

                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <h4>高級文法</h4>
                                    <p>Trinka可以糾正3000多種其他工具無法識別的複雜文法錯誤。 有了Trinka，寫作就能清晰明瞭。</p>
                                    <div class="featuresExampleText">
                                        <p>Neither the healthy individuals nor the patient
                                            <span class="wrongText">recognize</span>
                                            <span class="rightText">recognizes</span> the visual discrepancies.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>句構</h4>
                                    <p>Trinka會參考您的專業正確構建句子，使您的寫作易於理解。</p>
                                    <div class="featuresExampleText">
                                        <p>The students don't enjoy
                                            <span class="wrongText">to go</span>
                                            <span class="rightText">going</span> over the same rules again and again.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>選字</h4>
                                    <p>Trinka會修改導致表達不清楚的單詞。使用Trinka可以幫助您準確清晰地表達意圖。</p>
                                    <div class="featuresExampleText">
                                        <p>One of the reasons is
                                            <span class="wrongText">because</span>
                                            <span class="rightText">that</span> the fabrication cost
                                            <span class="wrongText">for</span>
                                            <span class="rightText">of</span> steel members depends upon the material.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>用法和風格</h4>
                                    <p>Trinka糾正措辭，使您的寫作更正式。用大膽精准的語言打動您的讀者。</p>
                                    <div class="featuresExampleText">
                                        <p>However, his method is novel and is
                                            <span class="wrongText">very much</span>
                                            <span class="rightText">considerably</span> different from the classical method.
                                        </p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>美式/英式風格</h4>
                                    <p>在美式和英式英語之間進行選擇，Trinka可以讓您的寫作適合讀者和期刊風格。</p>
                                    <div class="featuresExampleText">
                                        <p>The upper limbs of the patient were
                                            <span class="wrongText">paralysed</span>
                                            <span class="rightText">paralyzed.</span>
                                        </p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>高級拼寫</h4>
                                    <p>Trinka的上下文拼寫檢查可以根據學科專業領域選擇正確的單詞，讓您不再有難堪的拼寫錯誤。</p>
                                    <div class="featuresExampleText">
                                        <p>The
                                            <span class="wrongText">Bonferoni</span>
                                            <span class="rightText">Bonferroni</span> test was used to check for statistical significance.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="advanceGrammerSpellCheck_section publishEnhancements_slider">
        <div class="container">
            <div class="row">
                <div class="col-xl-7">
                    <div class="spellcheckGrammerCheck_slider">
                        <div id="publishEnhancements" class="carousel slide" data-ride="carousel">
                            <!-- Indicators -->
                            <div class="bullet_points_sections">
                                <ul class="carousel-indicators">
                                    <li data-target="#publishEnhancements" data-slide-to="0" class="active">
                                        <span></span>
                                        選定風
                                        <br />格指南
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="1">
                                        <span></span>
                                        字數縮減
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="2">
                                        <span></span>
                                        中性語言
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="3">
                                        <span></span>
                                        語意模糊
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="4">
                                        <span></span>
                                        專業領域
                                        <br />的措辭
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="5">
                                        <span></span>
                                        學術語調
                                    </li>
                                </ul>
                            </div>

                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <h4>選定風格指南</h4>
                                    <p>Trinka能根據AMA和APA等風格指南建議文句用字，使用Trinka做好發表文章的準備。</p>
                                    <div class="featuresExampleText">
                                        <p>The man
                                            <span class="wrongText">suffered from</span>
                                            <span class="rightText">had</span> chronic kidney disease.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>字數縮減</h4>
                                    <p>Trinka可以幫您簡化冗長的片語，輕鬆滿足期刊指南！</p>
                                    <div class="featuresExampleText">
                                        <p>Bcl6 deficiency in T cells resulted in
                                            <span class="wrongText">the reduction of
                                            </span>
                                            <span class="rightText">reduced</span> mRNA expression.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>中性語言</h4>
                                    <p>Trinka會糾正帶偏見和敏感的語言。使用Trinka能夠避免批評並且有效地表達自己的觀點。</p>
                                    <div class="featuresExampleText">
                                        <p>The
                                            <span class="wrongText">retarded children</span>
                                            <span class="rightText">children with mental retardation</span> were taken to a different facility.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>語意模糊</h4>
                                    <p>Trinka可以讓您的寫作更加具體和直接，輕鬆達到有效溝通。</p>
                                    <div class="featuresExampleText">
                                        <p>
                                            <span class="wrongText">Some studies</span>
                                            <span class="rightText">Studies</span> have shown that children not participating in co-curricular activities
                                            may not develop the necessary social skills in adulthood.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>專業領域的措辭</h4>
                                    <p>Trinka會根據您的專業領域建議正確的詞語，讓您的寫作內容與讀者建立連接。</p>
                                    <div class="featuresExampleText">
                                        <p>Anti-aquaporin 4 antibody testing may be useful in cases of pediatric
                                            <span class="wrongText">transverse myelitis with long spinal cord lesions
                                            </span>
                                            <span class="rightText">longitudinally extensive transverse myelitis.</span>
                                        </p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>學術語調</h4>
                                    <p>Trinka為您的作品提供正式的語調，給讀者留下深刻的印象。專業寫作現在變得容易！</p>
                                    <div class="featuresExampleText">
                                        <p>Children actively engage in activities
                                            <span class="wrongText">like</span>
                                            <span class="rightText">such as</span> outdoor games, skits, and other team activities.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-5">
                    <div class="spellcheck_heading">
                        <h2>幫您提高文章的寫作水準，做好出版準備</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka可以根據學術出版標準來提升您文章的語調，表達和措辭。 有了Trinka，學術寫作變得前所未有的輕鬆。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolboxs_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="writerBox_heading">
                        <h2>作者套餐</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections sections_height_set bg-right-position d-flex align-items-center" style="background-image: url('../../../assets/images/Reverstoolbox_backgrond_keyBenafits.png');">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content pc-check-img">
                            <img src="../../../assets/images/pc-checker.png" alt="">
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>抄襲檢測</h3>
                            <p>
                                透過更先進的文本相似性檢測演算法iThenticate和覆蓋所有科學領域的最大付費出版物資料庫，體驗高品質的抄襲檢查。
                            </p>
                            <a [routerLink]="['/features/plagiarism-check']">
                                瞭解更多
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="">
                            </a>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>自動文件編輯</h3>
                            <p>繼續在您喜歡的環境中工作。上傳您的MS Word文件，Trinka會在幾分鐘內自動編輯您的論文。您可以下載檔案並顯示修訂。</p>
                            <a href="https://www.trinka.ai/tw/features/auto-file-edit">
                                閱讀更多
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="">
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/autoFileEdit_image.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections publication_outer_sections sections_height_set">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content publication_checks_icons publication_checks_section">
                            <!-- <img src="../../../assets/images/PublicationReadinessChecksImg.png" alt=""> -->
                            <ul>
                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/JournalScope.svg" alt="">
                                    </div>
                                    <h3>期刊範圍匹配</h3>
                                    <span>2 Checks</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/TechnicalCompliance.svg" alt="technical compliance">
                                    </div>
                                    <h3>技術合規</h3>
                                    <span>3 Checks</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/EthicalCompliance.svg" alt="">
                                    </div>
                                    <h3>道德合規</h3>
                                    <span>5 Checks</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/AuthorshipDetails.svg" alt="">
                                    </div>
                                    <h3>作者詳細資訊</h3>
                                    <span>4 Checks</span>
                                </li>
                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/ReferenceDetails.svg" alt="reference details">
                                    </div>
                                    <h3>參考文獻的細節</h3>
                                    <span>1 Check</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/FirgureTable.svg" alt="">
                                    </div>
                                    <h3>圖表</h3>
                                    <span>2 Checks</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/ClinicalTrials.svg" alt="">
                                    </div>
                                    <h3>臨床試驗資訊</h3>
                                    <span>1 Check</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/KeywordsAndSummary.svg" alt="">
                                    </div>
                                    <h3>關鍵字和摘要</h3>
                                    <span>2 Checks</span>
                                </li>
                                <i></i>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>出版準備檢查</h3>
                            <p>使用Trinka的出版準備檢查，您可以透過從“期刊選擇”到“道德合規”的20多項檢查評估您的文件，從而增加論文被期刊錄用的機會。</p>
                            <!-- <b style="font-weight: 600;">Coming soon</b> -->
                            <a href="https://www.trinka.ai/tw/features/publication-readiness-checks">
                                閱讀更多
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections sections_height_set publicationCheckSections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>引文檢查器</h3>
                            <p>引文檢查器可以識別會削弱您研究前提和論證的引文，並幫助您為您的論文引用可信的、權威的引文。</p>
                            <a [routerLink]="['/features/citation-checker']">
                                閱讀更多
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="">
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="citationCheckAllFeaturSection">
                            <img src="../../../assets/images/CitationCheckAllFeaturePage.png" />
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>一致性檢查</h3>
                            <p>您可能找到了一個更好的詞來表達您的觀點，但手稿中可能有些地方使用了連字號，另外一些地方卻沒有使用連字號。請放心，Trinka的“一致性檢查”會檢測到整個文本中的這種不一致，無論長度如何，您都可以進行一鍵修改。</p>
                            <!-- <a href="">Read More</a> -->
                            <a [routerLink]="['/features/consistency-check']">
                                閱讀更多
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="">
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_img_content consistency_checks_slider">
                            <div class="consistency_checks_slider_overlay"></div>
                            <!-- <img src="../../../assets/images/consistencyCheck_img.png" alt=""> -->
                            <div class="slider_consistency_check_section">
                                <div id="consistencySlider" class="carousel slide" data-ride="carousel">
                                    <ul class="carousel-indicators">
                                        <li data-target="#consistencySlider" data-slide-to="0" class="active"></li>
                                        <li data-target="#consistencySlider" data-slide-to="1"></li>
                                        <li data-target="#consistencySlider" data-slide-to="2"></li>
                                        <li data-target="#consistencySlider" data-slide-to="3"></li>
                                        <li data-target="#consistencySlider" data-slide-to="4"></li>
                                    </ul>
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <div class="carousel_inner_content">
                                                <div class="consistency_right_text">
                                                    <h2>Dashes</h2>
                                                    <div class="custom_radioButtons">
                                                        <p>
                                                            <input type="radio" id="ultra-violet" name="dashesCehcks" checked>
                                                            <label for="ultra-violet">ultra-violet (5 occurrences) </label>
                                                        </p>
                                                        <p>
                                                            <input type="radio" id="ultra_violet" name="dashesCehcks">
                                                            <label for="ultra_violet">ultra violet (5 occurrences) </label>
                                                        </p>
                                                    </div>
                                                    <button>Apply selected variant</button>
                                                </div>
                                                <div class="consistency_left_side">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    <ul>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_IgnoreAll_Icons.svg" title="Ignore for all similler alerts" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item">
                                            <div class="carousel_inner_content">
                                                <div class="consistency_right_text">
                                                    <h2>Spacing</h2>
                                                    <div class="custom_radioButtons">
                                                        <p style="margin: 0;">
                                                            <input type="radio" id="addSpaicng" name="spacingChecks" checked>
                                                            <label for="addSpaicng">Add space</label>
                                                        </p>
                                                        <ul style="margin-bottom: 20px;">
                                                            <li>p
                                                                <0 <img src="../../../assets/images/spacingArrow.png" />p
                                                                < 0 </li>
                                                                    <li>p=0
                                                                        <img src="../../../assets/images/spacingArrow.png" />p = 0 </li>
                                                        </ul>
                                                        <p style="margin: 0px;">
                                                            <input type="radio" id="removingspacing" name="spacingChecks">
                                                            <label for="removingspacing">Remove space</label>
                                                        </p>
                                                        <ul>
                                                            <li>2D + DBT
                                                                <img src="../../../assets/images/spacingArrow.png" />2D+DBT</li>
                                                            <li>p
                                                                < 0 <img src="../../../assets/images/spacingArrow.png" />p
                                                                <0</li>
                                                        </ul>
                                                    </div>
                                                    <!-- <button>Apply selected variant</button> -->
                                                </div>
                                                <div class="consistency_left_side">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    <ul>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_IgnoreAll_Icons.svg" title="Ignore for all similler aterls" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item">
                                            <div class="carousel_inner_content">
                                                <div class="consistency_right_text">
                                                    <h2>Numbers</h2>
                                                    <div class="custom_radioButtons">
                                                        <p style="margin: 0;">
                                                            <input type="radio" id="spelledOut" name="numberschecks" checked>
                                                            <label for="spelledOut">Spelled-out
                                                                <img src="../../../assets/images/spacingArrow.png" /> Numeral</label>
                                                        </p>
                                                        <ul style="margin-bottom: 20px;">
                                                            <li>average six years
                                                                <img src="../../../assets/images/spacingArrow.png" />average 6 years </li>
                                                            <!-- <li>average 6 years <img src="../../../assets/images/spacingArrow.png"/>average six years </li> -->
                                                        </ul>
                                                        <p style="margin: 0px;">
                                                            <input type="radio" id="numeralSection" name="numberschecks">
                                                            <label for="numeralSection">Numeral
                                                                <img src="../../../assets/images/spacingArrow.png" /> Spelled-out</label>
                                                        </p>
                                                        <ul>
                                                            <li>waited 5 days
                                                                <img src="../../../assets/images/spacingArrow.png" />waited five days</li>
                                                            <!-- <li>p < 0 <img src="../../../assets/images/spacingArrow.png"/>p<0</li> -->
                                                        </ul>
                                                    </div>
                                                    <!-- <button>Apply selected variant</button> -->
                                                </div>
                                                <div class="consistency_left_side">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    <ul>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_IgnoreAll_Icons.svg" title="Ignore for all similler aterls" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item">
                                            <div class="carousel_inner_content">
                                                <div class="consistency_right_text">
                                                    <h2>Spelling</h2>
                                                    <div class="custom_radioButtons">
                                                        <p>
                                                            <input type="radio" id="colourSection" name="spellingchecks" checked>
                                                            <label for="colourSection">colour (4 occurences) </label>
                                                        </p>
                                                        <p>
                                                            <input type="radio" id="colorSections" name="spellingchecks">
                                                            <label for="colorSections">color (4 occurences) </label>
                                                        </p>
                                                    </div>
                                                    <button>Apply selected variant</button>
                                                </div>
                                                <div class="consistency_left_side">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    <ul>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_IgnoreAll_Icons.svg" title="Ignore for all similler aterls" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item">
                                            <div class="carousel_inner_content">
                                                <div class="consistency_right_text">
                                                    <h2>Greek Letter Style</h2>
                                                    <div class="custom_radioButtons">
                                                        <p style="margin: 0;">
                                                            <input type="radio" id="GreekSpelledOut" name="Greekletterstyle" checked>
                                                            <label for="GreekSpelledOut">Spelled-out
                                                                <img src="../../../assets/images/spacingArrow.png" /> Symbol</label>
                                                        </p>
                                                        <ul style="margin-bottom: 20px;">
                                                            <li>TNF-alpha"
                                                                <img src="../../../assets/images/spacingArrow.png" />tnf-α"</li>
                                                            <li>"Beta particles
                                                                <img src="../../../assets/images/spacingArrow.png" />"β particles</li>
                                                        </ul>
                                                        <p style="margin: 0px;">
                                                            <input type="radio" id="removingspacing" name="Greekletterstyle">
                                                            <label for="removingspacing">Symbol
                                                                <img src="../../../assets/images/spacingArrow.png" /> Spelled-out</label>
                                                        </p>
                                                        <ul>
                                                            <li>TNF-α"
                                                                <img src="../../../assets/images/spacingArrow.png" />TNF-alpha"</li>
                                                            <li>"β particles
                                                                <img src="../../../assets/images/spacingArrow.png" />"beta particles</li>
                                                        </ul>
                                                    </div>
                                                    <!-- <button>Apply selected variant</button> -->
                                                </div>
                                                <div class="consistency_left_side">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    <ul>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_IgnoreAll_Icons.svg" title="Ignore for all similler aterls" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections publication_outer_sections personal_outer_section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content publication_checks_section pd_after">
                            <div class="personal_dictionary_section">
                                <div class="personal_dic_left_text">
                                    <h2>Spelling
                                        <span>
                                            <i class="fa fa-plus"></i>Add to dictionary</span>
                                    </h2>
                                    <div class="personal_dic_text_section">
                                        <p class="personal_wrong_text">nanotubol</p>
                                        <img src="../../../assets/images/spacingArrow.png" />
                                        <p class="personal_right_text">nanotubes</p>
                                    </div>
                                    <p>Please check the spelling</p>
                                </div>
                                <div class="consistency_left_side">
                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                    <ul>
                                        <li>
                                            <img src="../../../assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                        </li>
                                        <!-- <li><img src="../../../assets/images/Consistency_IgnoreAll_Icons.svg" title="Ignore for all similler aterls" style="width: 22px;"></li> -->
                                        <li>
                                            <img src="../../../assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                        </li>
                                    </ul>
                                </div>

                            </div>
                            <!-- <img src="../../../assets/images/personalDictionary_img.png" alt=""> -->
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>個人詞典</h3>
                            <p>將自己的單詞添加到“我的詞典”中，這樣Trinka就不會在將來的寫作中將其標記為拼寫錯誤。</p>
                            <!-- <a href="">Read More</a> -->
                            <a [routerLink]="['/features/personal-dictionary']">
                                閱讀更多
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections downloadTrackedchangesOuter_section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>下載開啟了修訂功能的文件</h3>
                            <p>下載經過修訂的文件，該文件顯示了您在Trinka編輯工具中選擇的各項更改。</p>
                            <!-- <a href="">Read More</a> -->
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_img_content downloadTrackedchanges_section">
                            <!-- <img src="../../../assets/images/downloadTrackedChanged_img.png" alt=""> -->
                            <div class="downloadCleanFile">
                                <!-- <p class="cleanDownloadfile"></p> -->
                                <p>
                                    <span class='rightWordTExt'>However,</span> additional factors
                                    <span class='rightWordTExt'>influencing</span> patient prognosis and
                                    <span class='rightWordTExt'>reducing</span> HDL-C and Apo A1 levels were assessed.</p>
                            </div>
                            <div class="downloadWithTrackedChangesFile">
                                <!-- <p class="TrackedChangesFile"></p> -->
                                <p>
                                    <span class='wrognWordText'>On the other hand </span>
                                    <span class='rightWordTExt'>However,</span> additional factors
                                    <span class='wrognWordText'>which influence </span>
                                    <span class='rightWordTExt'>influencing</span> patient prognosis and
                                    <span class='wrognWordText'>leading to a reduction in </span>
                                    <span class='rightWordTExt'>reducing</span> HDL-C and Apo A1 levels were assessed.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections publication_outer_sections personal_outer_section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content publication_checks_section pd_after">
                            <div class="personal_dictionary_section">
                                <div class="personal_dic_left_text">
                                    <h2>Spelling
                                        <b>
                                            <i class="fa fa-plus"></i>Add to dictionary</b>
                                    </h2>
                                    <div class="personal_dic_text_section">
                                        <p class="personal_wrong_text">nanotubol</p>
                                        <img src="../../../assets/images/spacingArrow.png" />
                                        <p class="personal_right_text">nanotubes</p>
                                    </div>
                                    <div class="acceptAll_buttons_sections">
                                        <p>Accept for all similar alerts</p>
                                        <i>
                                            <img src="../../../assets/images/info.svg" alt="info icon">
                                        </i>
                                    </div>
                                    <p>Please check the spelling</p>
                                </div>
                                <div class="consistency_left_side">
                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                    <ul>
                                        <li>
                                            <img src="../../../assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                        </li>
                                        <li class="acceptAll_rejectAll">
                                            <img src="../../../assets/images/AcceptAll_consistencyCheks.svg" title="Ignore for all similler aterls" style="width: 22px;">
                                        </li>
                                        <li>
                                            <img src="../../../assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>全部接受/全部忽略</h3>
                            <p>不再需要重複點擊！ Trinka允許一鍵接受或忽略所有重複性建議。</p>
                            <!-- <a href="">Read More</a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="writeToolbox_inner_sections publication_outer_sections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content publication_checks_section acceptAll_outerSection">
                            <div class="acceptIgnore_all_section">
                                <a>
                                    <i class="fa fa-check" aria-hidden="true"></i>
                                    <i class="fa fa-plus"  aria-hidden="true"></i> 
                                    <span class="dictionary_text_section">Add to dictionary</span>
                                    <span class="dictionary_add_text">Added</span>
                                </a>
                                <b>Accept for all similler alert</b>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>Accept/Ignore All</h3>
                            <p>No more repetitive clicking! Trinka allows you to accept or ignore all repetitive
                                suggestions in one click.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

    </div>

    <div class="forpersonlized_sections">
        <p>您還在等什麼？</p>
        <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank">免費註冊！</a>
    </div>
</div>